/*eslint-disable */
import {
  bus
} from '../../main';
const $ = window.jQuery = require('jquery');
import router from '../../route';
import toast from '../../services/toast';
import covidPopup from '../../components/covid-19-popup';
import Register from '../register';
// Multi Color Bg Img Of Section
import random_img1 from './../../assets/images/random_img/lange_crub_1.jpg';
import random_img2 from './../../assets/images/random_img/lange_crub_2.jpg';
import random_img3 from './../../assets/images/random_img/lange_crub_3.jpg';
import random_img4 from './../../assets/images/random_img/lange_crub_4.jpg';
import random_img5 from './../../assets/images/random_img/lange_crub_5.jpg';
import random_img from './../../assets/images/lange_crub.jpg';
export default {
  name: 'login',
  components: {
    'covid-popup': covidPopup,
    'sign-up': Register
  },
  props: [],
  data() {
    return {
      redirectTo: '',
      identity: '',
      otp: '',
      submitted: false,
      preloader: true,
      loginFailed: false,
      showPasswordScreen: false,
      loginCHeck: true,
      randomImg: '',
      animationImg: '',
      first_slide: true,
      second_slide: false,
      emailMblError: false,
      countryCode: '+91',
      redirectTo: undefined,
      redirectToHash: undefined,
      redirectToHashFull: undefined,
      userCheckValidLogin: false,
      userCheckNotValidLogin: true,
      getDetailsOfLoginUser: '',
      userCheckNotValidLoginSecondScreen: false,
      otpInMobile: false,
      otpInEmail: false,
      verificationType: "",
      verfiyIdentity: '',
      mblLogined: false,
      signUpFormEnabled: false
    }
  },
  computed: {

  },
  mounted() {
    this.animationImg = random_img
    var _self = this
    $(document).ready(function (argument) {
      $(".more_info_add_btn").click(function () {
        $(".oncology_wel_lange_img .animation_start").addClass("d-none");
        $(".oncology_wel_lange_img .animation_stop").removeClass("d-none");
        $(".lymphomap_auth_center").toggleClass("active");
        $(".sign_up_btn").addClass("d-none")
        $(this).addClass("d-none");
      });
      $(document).click(function (event) {
        //if you click on anything except the modal itself or the "open modal" link, close the modal
        if (!$(event.target).closest(".lymphomap_auth_center, .more_info_add_btn").length) {
          $(".oncology_wel_lange_img .animation_start").removeClass("d-none");
          $(".oncology_wel_lange_img .animation_stop").addClass("d-none");
          $(".lymphomap_auth_center").removeClass("active");
          $('.more_info_add_btn').removeClass('d-none');
          $(".sign_up_btn").removeClass("d-none")
          //  _self.userCheckValidLogin = false
          //  _self.userCheckNotValidLogin = false
          //  $('.show_login_user_details').removeClass('d-none')
        }
      });
      $(document).ready(function (argument) {
        $(".lymphomap_ab_btn .btn").click(function () {
          $(window).scrollTop(0);
          $(".lymphomap_about").toggleClass("active");
          $('.covid_19_popup').toggleClass('covid_popup_disabled')
          $('.more_info_add').addClass('d-none')
        });
        $(document).click(function (event) {
          //if you click on anything except the modal itself or the "open modal" link, close the modal
          if (!$(event.target).closest(".lymphomap_ab_btn .btn,.light_bg_popup").length) {
            $("body").find(".lymphomap_about").removeClass("active");
            $("body").find('.covid_19_popup').removeClass('covid_popup_disabled')
            $('.more_info_add').removeClass('d-none')
          }
        });
      });
      $(document).ready(function (argument) {
        $(".lymphomap_computer_btn .btn").click(function () {
          $(window).scrollTop(0);
          $(".lymphomap_computer_data").toggleClass("active");
          $('body').addClass('covid_popup_disabled')
        });
        $(document).click(function (event) {
          //if you click on anything except the modal itself or the "open modal" link, close the modal
          if (!$(event.target).closest(".lymphomap_computer_btn .btn,.light_bg_popup").length) {
            $("body").find(".lymphomap_computer_data").removeClass("active");
            $('body').removeClass('covid_popup_disabled')
            setTimeout(() => {
              $('.lymphomap_computer_data .welcome_popup_inner').animate({ scrollTop: 0 });
            }, 300);
          }
        });
      });
      setTimeout(function () {
        $(".more_info_add").addClass("login_showing")
        $(".lymphomap_ab_btn").addClass("showing")
        $(".lymphomap_computer_btn").addClass("showing")
      }, 3000)
      $('.three_down_arrow').on('click', function (e) {
        e.preventDefault();
        var section_height = $('.lymphomap_computer_data_inner').height()
        console.log($(this).offset().top, section_height)
        $('.lymphomap_computer_data .welcome_popup_inner').animate({ scrollTop: section_height }, 500, 'linear');
      });
      $('.three_top_arrow').on('click', function (e) {
        e.preventDefault();
        $('.lymphomap_computer_data .welcome_popup_inner').animate({ scrollTop: 0 }, 500, 'linear');
      });
    });

    bus.$emit('showHeaderbtn', false);
    this.randomImg = random_img
    this.randomImgSlide()
    this.randomImgLoaded()
    setInterval(() => {
      this.randomImgSlide()
    }, 20000);
    setInterval(() => {
      this.randomImgLoaded()
    }, 21500);

    this.redirectTo = this.$route.query.redirect;
    this.redirectToHash = this.$route.hash
    this.redirectToHashFull = this.redirectTo + this.redirectToHash
    let redirect_login = this.redirectToHashFull.split('/')
    console.log(localStorage.getItem('token'), "Check Token")
    if (localStorage.getItem('token') != null && localStorage.getItem('LoginedUserID') != null) {
      this.loginCHeck = false
    } else {
      this.loginCHeck = true
    }
    bus.$on('showSignUpForm', (data) => {
      this.signUpFormEnabled = data;
    });
    $(document).ready(function (argument) {
      $(document).click(function (event) {
        //if you click on anything except the modal itself or the "open modal" link, close the modal
        if (!$(event.target).closest(".signup_form_main, .sign_up_btn").length) {
          $('body').removeClass('registration_form')
          _self.signUpFormEnabled = false
        }
      });
  });
  },
  methods: {
    signUpFormShow(){
      $(window).scrollTop(0);
      setTimeout(()=>{
        bus.$emit('showSignUpForm', true);
        $('body').addClass('registration_form')
      },1)
    },
    randomImgSlide() {
      setTimeout(() => {
        $(".oncology_well_new").addClass("active")
        $(".oncology_wel_popup").removeClass("active")
        setTimeout(() => {
          $(".oncology_well_new").css('z-index', '10')
          $(".oncology_wel_popup").css('z-index', '11')
          $(".oncology_wel_line_crub").addClass("animation_play")
        }, 1505)
      }, 10000)
      setTimeout(() => {
        $(".oncology_well_new").removeClass("active")
        $(".oncology_wel_popup").addClass("active")
        setTimeout(() => {
          $(".oncology_wel_popup").css('z-index', '10')
          $(".oncology_well_new").css('z-index', '11')
          $(".oncology_wel_line_crub").removeClass("animation_play")
        }, 1500)
      }, 20000)
    },
    randomImgLoaded() {
      setTimeout(() => {
        this.randomImg = random_img1
      }, 3500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 5500)
      setTimeout(() => {
        this.randomImg = random_img2
      }, 7500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 9500)
      setTimeout(() => {
        this.randomImg = random_img3
      }, 11500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 13500)
      setTimeout(() => {
        this.randomImg = random_img4
      }, 15500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 17500)
      setTimeout(() => {
        this.randomImg = random_img5
      }, 19500)
      setTimeout(() => {
        this.randomImg = random_img
      }, 21500)
    },
    keymonitor() {
      var __self = this
      var ep_emailval = $('#identity').val();
      var intRegex = /[0-9 -()+]+$/;
      if (intRegex.test(ep_emailval)) {
        if ((ep_emailval.length < 7) || (!intRegex.test(ep_emailval))) {
          // console.log(ep_emailval);
          __self.emailMblError = true
          $('.email_mbl_error').removeClass('d-none')
        } else {
          __self.emailMblError = false
          $('.email_mbl_error').addClass('d-none')
          this.mblLogined = true
        }
      } else {
        var eml = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (eml.test(ep_emailval) == false) {
          // console.log("is email");
          __self.emailMblError = true
          $('.email_mbl_error').removeClass('d-none')
        } else {
          __self.emailMblError = false
          $('.email_mbl_error').addClass('d-none')
          this.mblLogined = false
        }
      }

    },
    getUserCountry() {
      var self = this;
      fetch('https://api.ipdata.co?api-key=test')
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          console.log(json.parse(text.calling_code), "Get Country Code Defaults")
          self.countryCode = text.substr(2, 2)
        })
        .catch(function (error) {
          console.log('Request failed', error)
        });
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    showNextScreenForLogin() {
      if (this.validateEmail(this.identity)) {
        this.mblLogined = false
      } else {
        this.mblLogined = true
      }
      if (this.mblLogined == true) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$store.dispatch('checkUserLoginDetails', {
              mobile: this.identity
            })
              .then((res) => {
                if (res.status === 200) {
                  this.getDetailsOfLoginUser = res.data
                  toast.success(res.data.msg);
                  if (this.getDetailsOfLoginUser.data.mobile != null) {
                    this.userCheckNotValidLogin = false
                    this.userCheckNotValidLoginSecondScreen = true
                  } else {
                    this.userCheckNotValidLogin = false
                    this.userCheckValidLogin = true
                  }
                  // toast.success(res.data.msg);
                }
              }).catch((err) => {
                toast.error(err.data.data.non_field_errors || err.data.msg);
              })
            return;
          }
        });
      } else {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$store.dispatch('checkUserLoginDetails', {
              email: this.identity
            })
              .then((res) => {
                if (res.status === 200) {
                  this.getDetailsOfLoginUser = res.data
                  if (this.getDetailsOfLoginUser.data.mobile != null) {
                    this.userCheckNotValidLogin = false
                    this.userCheckNotValidLoginSecondScreen = true
                  } else {
                    this.$store.dispatch('checkLoginType', {
                      email: this.identity
                    }).then((res) => {
                      if (res.status === 200) {
                        this.verfiyIdentity = this.identity;
                        this.userCheckNotValidLogin = false
                        this.userCheckValidLogin = true
                        toast.success(res.data.user_msg);
                      }
                    }).catch((err) => {
                      toast.error(err.data.data.non_field_errors || err.data.msg);
                    })
                    return;
                  }
                  // toast.success(res.data.msg);
                }
              }).catch((err) => {
                toast.error(err.data.data.non_field_errors || err.data.msg);
              })
            return;
          }
        });
      }
    },
    validateLoginBeforeSubmit() {
      if (this.userCheckNotValidLogin) {
        this.showNextScreenForLogin();
      }
    },
    sendDataForLogin() {
      if (this.verificationType == 'email') {
        this.verfiyIdentity = this.getDetailsOfLoginUser.data.email;
        this.identity = this.getDetailsOfLoginUser.data.email;
      } else if (this.verificationType == 'Mobile') {
        this.verfiyIdentity = this.getDetailsOfLoginUser.data.mobile;
        this.identity = this.getDetailsOfLoginUser.data.mobile;
      }
      let sendKey = this.verificationType;
      if (sendKey == 'Mobile') {
        this.mblLogined = true
        this.$store.dispatch('checkLoginType', {
          mobile: this.verfiyIdentity
        })
          .then((res) => {
            if (res.status === 200) {
              toast.success(res.data.user_msg);
              this.userCheckValidLogin = true
              this.userCheckNotValidLoginSecondScreen = false
            }
          }).catch((err) => {
            toast.error(err.data.data.non_field_errors || err.data.msg);
          })
        return;
      } else {
        this.mblLogined = false
        this.$store.dispatch('checkLoginType', {
          email: this.verfiyIdentity
        })
          .then((res) => {
            if (res.status === 200) {
              toast.success(res.data.user_msg);
              this.userCheckValidLogin = true
              this.userCheckNotValidLoginSecondScreen = false
            }
          }).catch((err) => {
            toast.error(err.data.data.non_field_errors || err.data.msg);
          })
        return;
      }
    },
    userLoginFirstScreenShow() {
      setTimeout(() => {
        this.userCheckValidLogin = false
        this.userCheckNotValidLoginSecondScreen = false
        this.userCheckNotValidLogin = true
      }, 10)
    },
    validateBeforeSubmit(e) {
      if (this.mblLogined == true) {
        this.$validator.validateAll().then((result) => {
          this.submitted = true;
          if (result) {
            this.$store.dispatch('loginWithOtp', {
              mobile: this.verfiyIdentity,
              otp: this.otp
            })
              .then((res) => {
                if (res.data.code == '2000') {
                  toast.success(res.data.msg);
                  if (this.redirectTo != undefined && this.redirectToHash != undefined) {
                    let redirect_login = this.redirectToHashFull.split('/')
                    if (redirect_login[redirect_login.lastIndexOf('')] = '') {
                      this.$router.push('/home/');
                    } else {
                      this.$router.push({
                        path: this.redirectToHashFull
                      });
                    }
                  } else {
                    this.$router.push('/home/');
                  }
                }
              }).catch((err) => {
                toast.error(err.data.user_msg);
                this.otp = '',
                  this.userCheckNotValidLogin = true
                this.userCheckNotValidLoginSecondScreen = false
                this.userCheckValidLogin = false
                this.otpInEmail = false
                this.otpInMobile = false
                this.verificationType = '';
              })
            return;
          }
          alert('Correct them errors!');
        });
      } else {
        this.$validator.validateAll().then((result) => {
          this.submitted = true;
          if (result) {
            this.$store.dispatch('loginWithOtp', {
              email: this.verfiyIdentity,
              otp: this.otp
            })
              .then((res) => {
                if (res.data.code == '2000') {
                  toast.success(res.data.msg);
                  if (this.redirectTo != undefined && this.redirectToHash != undefined) {
                    let redirect_login = this.redirectToHashFull.split('/')
                    if (redirect_login[redirect_login.lastIndexOf('')] = '') {
                      this.$router.push('/home/');
                    } else {
                      this.$router.push({
                        path: this.redirectToHashFull
                      });
                    }
                  } else {
                    this.$router.push('/home/');
                  }
                }
              }).catch((err) => {
                toast.error(err.data.user_msg);
                this.otp = '',
                  this.userCheckNotValidLogin = true
                this.userCheckNotValidLoginSecondScreen = false
                this.userCheckValidLogin = false
                this.otpInEmail = false
                this.otpInMobile = false
                this.verificationType = '';
                this.mblLogined = false
              })
            return;
          }
          alert('Correct them errors!');
        });
      }
    },
    checkSendOtpOnThat(val) {
      if (val == 'email') {
        this.otpInEmail = false
        this.otpInMobile = true
        this.verificationType = 'email';
      } else if (val == 'mobile_no') {
        this.otpInEmail = true
        this.otpInMobile = false
        this.verificationType = 'Mobile';
      }
    },
    maskString(fieldStr, digits, type = "") {
      let str = fieldStr;
      let domain = "";
      if (type == 'email') {
        domain = fieldStr.substring(fieldStr.lastIndexOf("@"));
        str = fieldStr.substring(0, fieldStr.lastIndexOf("@"));
      }
      str = '*'.repeat(str.length - digits) + str.slice(-digits) + domain;
      return str;
    }
  },
  beforeCreate: function () {
    $('body').addClass('login_body')
    $('.show_login_user_details').removeClass('d-none')
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('login_body')
    $('.show_login_user_details').removeClass('d-none')
    $(".sign_up_btn").removeClass("d-none")
    next();
  },
}
